import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import SmartFeedPreview from "%/dynamic-component-editor/options/smart-feed-preview";
import SmartFeedLayout from "%/dynamic-component-editor/options/smart-feed-layout";
import SmartFeedCardLayout from "%/dynamic-component-editor/options/smart-feed-card-layout";
import SmartFeedSelection from "%/dynamic-component-editor/options/smart-feed-selection";
import HashtagSelector from "%/dynamic-component-editor/options/hashtag-selector";
import StoryTypeSelector from "%/dynamic-component-editor/options/story-type-selector";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import CollectionItemContext from "%/dynamic-component-editor/options/collection-item-context";
import ProductLinkCollection from "%/dynamic-component-editor/options/product-link-collection";
import FilterIcon from "%/dynamic-component-editor/options/filter-icon";
import FilterLabelText from "%/dynamic-component-editor/options/filter-label-text";
import FilterToolbarBackgroundColor from "%/dynamic-component-editor/options/filter-toolbar-background-color";
import FilterToolbarFontColor from "%/dynamic-component-editor/options/filter-toolbar-font-color";
import FilterToolbarUnselectedFontColor from "%/dynamic-component-editor/options/filter-toolbar-unselected-font-color";
import FilterToolbarPadding from "%/dynamic-component-editor/options/filter-toolbar-padding";
import FilterToolbarMargins from "%/dynamic-component-editor/options/filter-toolbar-margins";
import FilterToolbarAlignment from "%/dynamic-component-editor/options/filter-toolbar-alignment";
import FilterToolbarLabelPosition from "%/dynamic-component-editor/options/filter-toolbar-label-position";
import FilterToolbarIconColor from "%/dynamic-component-editor/options/filter-toolbar-icon-color";
import SmartFeedPagination from "%/dynamic-component-editor/options/smart-feed-pagination";
import SmartFeedPageLimit from "%/dynamic-component-editor/options/smart-feed-page-limit";
import SmartFeedSeeAllDestination from "%/dynamic-component-editor/options/smart-feed-see-all-destination";
import SmartFeedSeeMoreText from "%/dynamic-component-editor/options/smart-feed-see-more-text";
import SmartFeedSeeAllText from "%/dynamic-component-editor/options/smart-feed-see-all-text";
import SmartFeedSeeMoreAlignment from "%/dynamic-component-editor/options/smart-feed-see-more-alignment";
import SmartFeedShowSelection from "%/dynamic-component-editor/options/smart-feed-show-selection";
import SmartFeedSeasonSelection from "%/dynamic-component-editor/options/smart-feed-season-selection";
import SmartFeedColumnMinWidth from "%/dynamic-component-editor/options/smart-feed-column-min-width";
import SmartFeedColumnMaxWidth from "%/dynamic-component-editor/options/smart-feed-column-max-width";
import SmartFeedFiltersToShow from "%/dynamic-component-editor/options/smart-feed-filters-to-show";
import FeedRowComponentId from "%/dynamic-component-editor/options/feed-row-component-id";
import FeedRowContextName from "%/dynamic-component-editor/options/feed-row-context-name";

export default class GlobalFeedOptions extends BaseOptionsBundle {

  optionTitle = "Feed Options";
  static optionClassName = "i-dynamic-global-feed-bundle";

  inspectorToolGroup = "global-feed";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.GLOBAL_FEED_TOOL_SET,
  };

  constructor(values = {}) {

    super(values, [
      SmartFeedPreview,
      SmartFeedSelection,
      SmartFeedShowSelection,
      SmartFeedSeasonSelection,
      SmartFeedLayout,
      SmartFeedCardLayout,
      HashtagSelector,
      StoryTypeSelector,
      CollectionItemContext,
      ProductLinkCollection,
      FilterIcon,
      FilterLabelText,
      FilterToolbarBackgroundColor,
      FilterToolbarFontColor,
      FilterToolbarUnselectedFontColor,
      FilterToolbarPadding,
      FilterToolbarMargins,
      FilterToolbarAlignment,
      FilterToolbarLabelPosition,
      FilterToolbarIconColor,
      SmartFeedPagination,
      SmartFeedPageLimit,
      SmartFeedSeeAllDestination,
      SmartFeedSeeMoreText,
      SmartFeedSeeMoreAlignment,
      SmartFeedSeeAllText,
      SmartFeedColumnMinWidth,
      SmartFeedColumnMaxWidth,
      SmartFeedFiltersToShow,
      FeedRowComponentId,
      FeedRowContextName,
    ]);
  }
}
